/* eslint-disable */
export default {
  title: 'Audio',
  input: 'Entrée',
  microphone: 'Micro',
  autoAdjustMicLevel: 'Régler automatiquement le niveau de mon micro',
  output: 'Sortie',
  speakerSource: 'Source du haut-parleur',
  speakerVolume: 'Volume du haut-parleur',
  ringtoneSource: 'Source de la sonnerie et des notifications',
  ringtoneVolume: 'Volume de la sonnerie et des notifications',
  ringtones: 'Sonneries',
  noDevices: 'Aucun terminal',
  off: 'Désactivé',
  noLabel: 'Périphérique inconnu',
  stopRecordDescription:
    'Dites quelque chose pour vérifier le niveau de votre micro ({countDown} secondes)',
  stopPlaybackDescription: 'Lecture de votre enregistrement…',
  startRecordButton: 'Tester le micro',
  stopRecordButton: 'Arrêter l’enregistrement',
  stopPlaybackButton: 'Arrêter le test',
  startTestButton: 'Tester le haut-parleur',
  stopTestDescription: 'Lecture de l’échantillon sonore…',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
